import { Component, OnInit, HostListener } from '@angular/core';
import { MSALInstanceService } from '../../services/msal-instance.service'; // if you have a custom MSAL service
import { MsalBroadcastService } from '@azure/msal-angular';
import { AuthenticationResult, EventMessage, EventType } from '@azure/msal-browser';
import { AuthService } from '../../services/auth.service'; // if you have a custom auth service
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { LanguageService } from 'src/app/services/language.service';
import { GaService } from 'src/app/services/ga.service';

@Component({
  selector: 'app-authentication-new',
  templateUrl: './authentication_new.component.html',
  styleUrls: ['./authentication_new.component.scss']
})
export class AuthenticationNewComponent implements OnInit {
    public termsLink = 'https://www.iaa.org.il/page/usage';
  public privacyLink = 'https://www.iaa.org.il/page/privacy';
  videoUrl: string = "https://www.example.com/video";
  public yoavEmail = 'yoav@israntique.org.il';
  public mokediaaEmail = 'mokediaa@israntique.org.il'
  public entityTypeNumbers: any
  showFullText = false;
  public currentLanguage="";
  showFullDescription = false; // Add property to track expanded description
  isMobile = window.innerWidth < 768;

  private hoveredIcons: { [key: string]: boolean } = {};

  @HostListener('window:resize')
  onResize() {
    this.isMobile = window.innerWidth < 768;
  }

  constructor(
    private msalInstanceService: MSALInstanceService,
    private msalBroadcastService: MsalBroadcastService,
    private authService: AuthService,
    private languageService: LanguageService,
    public gaService:GaService

  ) { }
  ngOnInit() {    

this.languageService.currentLanguage$.subscribe(lang => {
      this.currentLanguage = lang;
    });  

this.entityTypeNumbers = (window as any).entityTypeNumbers || {};
    this.msalBroadcastService.msalSubject$.subscribe((event: EventMessage) => {
      if (event.eventType === EventType.LOGIN_SUCCESS) {
        const result = event.payload as AuthenticationResult;
        if (this.msalInstanceService.msalInstance) {
          this.msalInstanceService.msalInstance.setActiveAccount(result.account);
        }

        this.authService.updateLoginStatus(true);
      }
      if (event.eventType === EventType.LOGIN_FAILURE) {
        console.log('Login failed', event.payload);
      }
    });
  }
  openVideo(){
    if(this.currentLanguage === 'he'){
      window.open('https://youtu.be/SA3I2STQxtI', '_blank');
    }
    else{
    window.open('https://youtu.be/1TwYeoQ5-Es', '_blank');
    }
  }

  loginAsGuest(): void {
    this.authService.loginAsGuest();
    this.authService.setInternalUser(false);
  }
  async switchToB2C(): Promise<void> {
    this.gaService.trackWithGA('OtherLogin','authentication',);
    await this.msalInstanceService.switchInstance('b2c');
  }

  async switchToEntraId(): Promise<void> {
    this.gaService.trackWithGA('IIALogin','authentication',);
    await this.msalInstanceService.switchInstance('entraId');
  }
  getModelsLink(): string {
    if (this.currentLanguage == 'he') {
      return 'https://experience.arcgis.com/experience/08c0ac0049044d1d8a86044545c152d0?locale=he';

    }
    else{
      return 'https://experience.arcgis.com/experience/fe0c17b263fc4641b684a559c0571944';
    }
}
  onIconHover(iconName: string, isHovering: boolean): void {
    this.hoveredIcons[iconName] = isHovering;
  }

  getIconSrc(iconName: string): string {
    const isHovering = this.hoveredIcons[iconName];
    return `assets/${iconName}${isHovering ? '_b' : ''}.svg`;
  }

  toggleDescription(): void {
    this.showFullDescription = !this.showFullDescription;
  }

}
